<template>
  <emd-tippy
    v-if="showTippy"
    position="top"
    type="html"
    aria-expanded="true"
    data-testid="emd-tippy-dash-info-icon"
    :id="tooltipId"
    :data-template="tooltipId"
  >
    <em class="emd-text eu-ml_1 _color_success uil uil-info-circle" />
    <emd-tippy-template-HTML :id="tooltipId">
      <emd-text
        v-for="item in tooltipList"
        :key="item.name"
        size="tiny"
        data-testid="emd-text-dash-info-icon"
      >
        {{ $t(item.name) }}
        <template v-if="item.percentage">: {{ item.percentage }}%</template>
        <br />
      </emd-text>
    </emd-tippy-template-HTML>
  </emd-tippy>
</template>

<script>
import {
  EmdText,
  EmdTippy,
  EmdTippyTemplateHTML
} from 'emerald-vue/src/components'

export default {
  name: 'ConversionsTooltip',

  components: {
    EmdText,
    EmdTippy,
    EmdTippyTemplateHTML
  },

  props: {
    tooltipList: {
      type: Array,
      default: () => []
    },
    tooltipId: {
      type: String,
      default: 'conversions_info-tippy'
    }
  },

  computed: {
    showTippy () {
      return this.tooltipList?.length > 0
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "conversion": {
        "cards": "Calculada com base nas transações de cartão finalizadas com sucesso, incluindo as retentativas."
      }
    },
    "en-US": {
      "conversion": {
        "cards": "Calculated based on successfull card transactions, including retries"
      }
    }
  }
</i18n>
